import { render, staticRenderFns } from "./IsLink.vue?vue&type=template&id=bf97d63c"
import script from "./IsLink.vue?vue&type=script&lang=js"
export * from "./IsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports